import React from 'react';

const SystemNotifications = ({ activeNotifications, setNotifications, activeServiceID }) => {

  const acknowledge = async (notification) => {
    if (window.confirm("Are you sure you want to acknowledge this notification?")) {
      const response = await fetch(notification.acknowledge_path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok ) {
        console.error("Failed to acknowledge");
        return;
      }
      setNotifications(prev => ({
        ...prev,
        [activeServiceID]: prev[activeServiceID].filter(
          n => n.id !== notification.id
        )
      }));
    }
  };

  return (
    <div className="service-system-notifications mt-5">
      <h6 className="mb-1">System notifications</h6>
      <ul>
        {activeNotifications.map((notification) =>
          <li
            key={`system-notification-${notification.id}`}
            className="compact-system-notification"
          >
            <a
              href={notification.show_path}
              className="title-link"
            >
              {notification.title}
            </a>
            {
              notification.can_acknowledge ?
                <button
                  className={`btn btn-sm btn-primary text-nowrap`}
                  onClick={() => acknowledge(notification)}
                >
                  Acknowledge
                </button> : ""
            }
          </li>
        )}
      </ul>
    </div>
  )
}

export default SystemNotifications;
